// This is just an example,
// so you can safely delete all default props below

export default {
    forget_password: 'Forget Password',
    email: 'Email',
    send: 'Send',
    succeeded:'Email Send Success'
}
